
import {Options, Vue} from 'vue-class-component';
import Main from "@/router/layouts/main.vue";

@Options({
    components: {Main},
})
export default class App extends Vue {
}

